import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { Location } from 'history';
import client from 'lib/CommonApi/client';
import { callAlertWeb, callAppLoginWeb, callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import { WEBVIEW_RESOURCE_VERSION } from 'common/cacheOverwrite';
import { CardProductCode } from '../../constants/Card';

const NologinProductDetailPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** Params */
  const { cardProductCode } = useParams();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL02";
  const screenName = t("APPL02.title");

  const [productDetail, setProdcutDetail] = useState<Product>();

  /** backKeyEvent_App 처리 (APP > WEB) */
  const callbackBackkeyEvent = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  /** 카드상품 조회 */
  const callProductDetail = useCallback(async () => {
    await client.get("/api/nologin/product/" + cardProductCode, { params: location.state.query }).then(response => {
      setProdcutDetail(response.data.response);
    }).catch((e: AxiosError) => {
      callAlertWeb("ERROR", "99", e.message);
    });
  }, [cardProductCode, location]);

  /** 카드신청 클릭 */
  const clickApply = useCallback(() => {
    callAppLoginWeb();
  }, []);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName);
    // 하단바 숨기기
    footerShowEventWeb("N");

    console.log("QUERY STATE");
    console.log(location.state);

    callProductDetail();

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <iframe
          className="productDetail"
          src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/benefit/${cardProductCode}/detail/card_detail_benefit.html?v=${WEBVIEW_RESOURCE_VERSION}&lang=${location.state.query.languageCode}`}
          allowFullScreen={true}
          title={productDetail?.cardProductCodeName}
        />
        <div className="btnArea">
          <div className="btnWrapTy01">
            <button
              type="button"
              className="btnPrimaryTy01"
              onClick={clickApply}>
              <span>
                {Number(cardProductCode) === CardProductCode.QuickCard
                  ? t('APPL01.listButton04', 'Register Card')
                  : t('APPL02.apply')}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NologinProductDetailPage;